module.exports = __webpack_public_path__ + "assets/images/left.svg?ver=b1466cfd";